import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: "none",
    "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
        display: "none",
    },
}));

export { PeekTabs, PeekTabs as default };
